
import React from 'react';
import {FormHelper} from '../../../dist/src/index';


const store = {}
export const attributes = {"title":"Basic Form"};
export default class extends React.Component {
  constructor() {
    super()
    this.state = {}
  }
  render() {
    return (
      <div>
        {(store.example = <FormHelper
  saveButton='Login'
  onSave={credentials => this.setState({credentials})}
  fields={[
    {path: ['email'], label: 'Email'},
    {path: ['password'], label: 'Password', type: 'password'},
    {path: ['rememberMe'], label: 'Remember me', type: 'checkbox'},
  ]}
/>
, null)}<h4>Basic form</h4>
<p>A very basic sign in form.</p>
<h6>Code</h6>

    <div className="example">
      <div className="source">
        <pre><code className="language-jsx">
          <span className="token tag"><span className="token tag"><span className="token punctuation">&lt;</span>FormHelper</span>{"\n"}  <span className="token attr-name">saveButton</span><span className="token attr-value"><span className="token punctuation">=</span><span className="token punctuation">'</span>Login<span className="token punctuation">'</span></span>{"\n"}  <span className="token attr-name">onSave</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span>credentials <span className="token operator">=</span><span className="token operator">></span> <span className="token keyword">this</span><span className="token punctuation">.</span><span className="token function">setState</span><span className="token punctuation">(</span><span className="token punctuation">{"{"}</span>credentials<span className="token punctuation">{"}"}</span><span className="token punctuation">)</span><span className="token punctuation">{"}"}</span></span>{"\n"}  <span className="token attr-name">fields</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span><span className="token punctuation">[</span>{"\n"}    <span className="token punctuation">{"{"}</span>path<span className="token punctuation">:</span> <span className="token punctuation">[</span><span className="token string">'email'</span><span className="token punctuation">]</span><span className="token punctuation">,</span> label<span className="token punctuation">:</span> <span className="token string">'Email'</span><span className="token punctuation">{"}"}</span><span className="token punctuation">,</span>{"\n"}    <span className="token punctuation">{"{"}</span>path<span className="token punctuation">:</span> <span className="token punctuation">[</span><span className="token string">'password'</span><span className="token punctuation">]</span><span className="token punctuation">,</span> label<span className="token punctuation">:</span> <span className="token string">'Password'</span><span className="token punctuation">,</span> type<span className="token punctuation">:</span> <span className="token string">'password'</span><span className="token punctuation">{"}"}</span><span className="token punctuation">,</span>{"\n"}    <span className="token punctuation">{"{"}</span>path<span className="token punctuation">:</span> <span className="token punctuation">[</span><span className="token string">'rememberMe'</span><span className="token punctuation">]</span><span className="token punctuation">,</span> label<span className="token punctuation">:</span> <span className="token string">'Remember me'</span><span className="token punctuation">,</span> type<span className="token punctuation">:</span> <span className="token string">'checkbox'</span><span className="token punctuation">{"}"}</span><span className="token punctuation">,</span>{"\n"}  <span className="token punctuation">]</span><span className="token punctuation">{"}"}</span></span>{"\n"}<span className="token punctuation">/></span></span>{"\n"}
        </code></pre>
      </div>
    </div><h6>Demo</h6>

    <div className="example">
      <div className="run"><div>
  {store.example}
</div>
</div>
    </div>
  <h6>State</h6>

    <div className="example">
      <div className="run"><div>
  <p>
    Credentials: {JSON.stringify(this.state.credentials)}
  </p>
</div>
</div>
    </div>
  
      </div>
    );
  }
};


/** WEBPACK FOOTER **
 ** ./docs/pages/Examples/01-basic-form.md
 **/